import useUserContext from '../../../contexts/UserContext/useUserContext';
import { dashboardFunctionsService } from '../functions/DashboardFunctionsService';
import { dependentesFunctionsService } from '../functions/DependentesFunctionsService';
import { rfidFunctionsService } from '../functions/RfidFunctionsService';
import { saldoFunctionsService } from '../functions/SaldoFunctionsService';
import { vendaFunctionsService } from '../functions/VendaFunctionsService';
import { viewConciliacaoVendas } from '../views/ViewConciliacaoVendas';
import { viewMovimentacoesRecentes } from '../views/ViewMovimentacoesRecentes';
import { viewRelatorios } from '../views/ViewRelatorios';
import { viewRestricoesAlimentares } from '../views/ViewRestricoesAlimentares';
import { viewSaldosAlunos } from '../views/ViewSaldosAlunos';
import { viewSaldosResponsaveis } from '../views/ViewSaldosResponsaveis';
import { cardapioDiarioService } from './CardapioDiarioService';
import { configuracoesService } from './ConfiguracoesService';
import { contratosService } from './ContratosService';
// import { CreditosDependentesService } from './CreditosDependentesService';
// import { CreditosDepositosService } from './CreditosDepositosService';
// import { CreditosService } from './CreditosService';
import { EnderecosService } from './EnderecosService';
// import { MovimentacoesSaldoService } from './MovimentacoesSaldoService';
import { organizacoesService } from './OrganizacoesService';
import { PagamentosService } from './PagamentosService';
import { PessoasDependentesService } from './PessoasDependentesService';
import { PessoasOrganizacoesService } from './PessoasOrganizacoesService';
import { pessoasService } from './PessoasService';
import { produtosGruposService } from './ProdutosGruposService';
import { produtosService } from './ProdutosService';
import { produtosSubGruposService } from './ProdutosSubGruposService';
import { SaldosAlunosService } from './SaldosAlunosService';
import { SaldosResponsaveisService } from './SaldosResponsaveisService';
import { SistemaOrigemService } from './SistemaOrigemService';
import { SolicitacoesService } from './SolicitacoesService';
import { TelefonesService } from './TelefonesService';
import { tipoPessoaService } from './TipoPessoaService';
import { TipoUnidadeService } from './TipoUnidadeService';
import { usuariosRfidService } from './UsuariosRfidService';
import { VendasItensService } from './VendasItensService';
import { vendasService } from './VendasService';

// Instâncias dos novos services
const telefonesService = new TelefonesService();
// const creditosService = new CreditosService();
// const creditosDepositosService = new CreditosDepositosService();
// const creditosDependentesService = new CreditosDependentesService();
const enderecosService = new EnderecosService();
// const movimentacoesSaldoService = new MovimentacoesSaldoService();
const pagamentosService = new PagamentosService();
const pessoasDependentesService = new PessoasDependentesService();
const pessoasOrganizacoesService = new PessoasOrganizacoesService();
const sistemaOrigemService = new SistemaOrigemService();
const solicitacoesService = new SolicitacoesService();
const tipoUnidadeService = new TipoUnidadeService();
const vendasItensService = new VendasItensService();

/**
 * Hook personalizado que fornece acesso aos serviços com contexto multi-tenant automático
 * Todos os métodos dos serviços são automaticamente chamados com o ID da organização do usuário logado
 */
export const useMultiTenantServices = () => {
     const { userData } = useUserContext();

     const organizationId = userData?.fk_id_organizacao;
     const userId = userData?.id!;

     // Validação rigorosa para evitar NaN
     if (!userData || !organizationId || isNaN(organizationId) || organizationId <= 0) {
          // Retorna um objeto com todas as funções como no-op para evitar erros
          return {
               pessoas: {} as any,
               vendas: {} as any,
               saldosResponsaveis: {} as any,
               saldosAlunos: {} as any,
               tipos: {} as any,
               grupos: {} as any,
               subgrupos: {} as any,
               produtos: {} as any,
               cardapio: {} as any,
               contratos: {} as any,
               pacotes: {} as any,
               pacotesItens: {} as any,
               context: {
                    organizationId: null,
                    userId: null,
                    userData: null,
               },
               organizacoes: organizacoesService,
               relatorios: {} as any,
               configuracoes: {} as any,
               usuariosRfid: {} as any,
               telefones: {} as any,
               enderecos: {} as any,
               creditos: {} as any,
               creditosDepositos: {} as any,
               creditosDependentes: {} as any,
               tipoUnidade: {} as any,
               solicitacoes: {} as any,
               pagamentos: {} as any,
               movimentacoesSaldo: {} as any,
               pessoasOrganizacoes: {} as any,
               pessoasDependentes: {} as any,
               vendasItens: {} as any,
               sistemaOrigem: {} as any,
               conciliacaoVendas: {} as any,
               viewSaldosResponsaveis: {} as any,
               viewSaldosAlunos: {} as any,
               viewMovimentacoesRecentes: {} as any,
               rfidFunctions: {} as any,
               saldoFunctions: {} as any,
               dashboardFunctions: {} as any,
               dependentesFunctions: {} as any,
               vendaFunctions: {} as any,
          };
     }

     return {
          restricoesAlimentares: {
               getAll: (page: number = 1, pageSize: number = 50, sortModel?: any, filterModel?: any) => viewRestricoesAlimentares.getAll(Number(organizationId) || 0, page, pageSize, sortModel, filterModel),
               getById: (id: number) => viewRestricoesAlimentares.getById(id, organizationId),
          },
          // Serviços base com organização automática
          pessoas: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => pessoasService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => pessoasService.getAllActive(organizationId),
               getById: (id: number) => pessoasService.getById(id, organizationId),
               getByTipo: (tipoId: number) => pessoasService.getByTipo(organizationId, tipoId),
               getByDocumento: (documento: string) => pessoasService.getByDocumento(organizationId, documento),
               getByEmail: (email: string) => pessoasService.getByEmail(organizationId, email),
               getAlunosByResponsavel: (responsavelId: number) => pessoasService.getAlunosByResponsavel(organizationId, responsavelId),
               getResponsaveisByAluno: (alunoId: number) => pessoasService.getResponsaveisByAluno(organizationId, alunoId),
               create: (data: any) => pessoasService.create(data, organizationId, userId),
               update: (id: number, data: any) => pessoasService.update(id, data, organizationId, userId),
               softDelete: (id: number) => pessoasService.softDelete(id, organizationId, userId),
               canDelete: (id: number) => pessoasService.canDelete(id, organizationId),
          },

          vendas: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => vendasService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getVendasHoje: () => vendasService.getVendasHoje(organizationId),
               getVendasPorPeriodo: (dataInicio: string, dataFim: string) => vendasService.getVendasPorPeriodo(organizationId, dataInicio, dataFim),
               getVendasPorAluno: (alunoId: number, limit?: number) => vendasService.getVendasPorAluno(organizationId, alunoId, limit),
               getVendasPorResponsavel: (responsavelId: number, limit?: number) => vendasService.getVendasPorResponsavel(organizationId, responsavelId, limit),
               getVendasPendentes: () => vendasService.getVendasPendentes(organizationId),
               processarVenda: (vendaData: any) => vendasService.processarVenda(organizationId, vendaData, userId),
               confirmarRetirada: (id: number) => vendasService.confirmarRetirada(id, organizationId, userId),
               cancelarVenda: (id: number, motivo: string) => vendasService.cancelarVenda(id, organizationId, motivo, userId),
               getRelatorioVendas: (dataInicio: string, dataFim: string) => vendasService.getRelatorioVendas(organizationId, dataInicio, dataFim),
               getDashboardVendas: () => vendasService.getDashboardVendas(organizationId),
          },

          saldosResponsaveis: {
               getAllWithResponsaveis: () => SaldosResponsaveisService.getAllWithResponsaveis(organizationId),
               getSaldoByResponsavel: (responsavelId: number) => SaldosResponsaveisService.getSaldoByResponsavel(organizationId, responsavelId),
               adicionarCredito: (responsavelId: number, valor: number, tipoPagamento: string, numeroComprovante?: string, observacoes?: string) => SaldosResponsaveisService.adicionarCredito(organizationId, responsavelId, valor, tipoPagamento, userId, numeroComprovante, observacoes),
               bloquearSaldo: (responsavelId: number, valor: number) => SaldosResponsaveisService.bloquearSaldo(organizationId, responsavelId, valor, userId),
               desbloquearSaldo: (responsavelId: number, valor: number) => SaldosResponsaveisService.desbloquearSaldo(organizationId, responsavelId, valor, userId),
               getRelatorioMovimentacoes: (responsavelId: number, dataInicio?: string, dataFim?: string) => SaldosResponsaveisService.getRelatorioMovimentacoes(organizationId, responsavelId, dataInicio, dataFim),
          },

          saldosAlunos: {
               getAllWithAlunos: () => SaldosAlunosService.getAllWithAlunos(organizationId),
               getSaldoByAluno: (alunoId: number) => SaldosAlunosService.getSaldoByAluno(organizationId, alunoId),
               getSaldosByResponsavel: (responsavelId: number) => SaldosAlunosService.getSaldosByResponsavel(organizationId, responsavelId),
               definirLimites: (alunoId: number, limiteDiario: number, limiteSemanal: number) => SaldosAlunosService.definirLimites(organizationId, alunoId, limiteDiario, limiteSemanal, userId),
               verificarLimiteCompra: (alunoId: number, valorCompra: number) => SaldosAlunosService.verificarLimiteCompra(organizationId, alunoId, valorCompra),
               getRelatorioConsumo: (alunoId: number) => SaldosAlunosService.getRelatorioConsumo(organizationId, alunoId),
          },

          tipos: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => tipoPessoaService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => tipoPessoaService.getAllActive(organizationId),
               getAllOrdenadoPorNivel: () => tipoPessoaService.getAllOrdenadoPorNivel(organizationId),
               getById: (id: number) => tipoPessoaService.getById(id, organizationId),
               getByNome: (nome: string) => tipoPessoaService.getByNome(organizationId, nome),
               getByNivelAcessoMinimo: (nivelMinimo: number) => tipoPessoaService.getByNivelAcessoMinimo(organizationId, nivelMinimo),
               verificarPermissao: (tipoId: number, permissao: string) => tipoPessoaService.verificarPermissao(organizationId, tipoId, permissao),
               create: (data: any) => tipoPessoaService.create(data, organizationId, userId),
               update: (id: number, data: any) => tipoPessoaService.update(id, data, organizationId, userId),
               updatePermissoes: (id: number, permissoes: any) => tipoPessoaService.updatePermissoes(id, organizationId, permissoes, userId),
               softDelete: (id: number) => tipoPessoaService.softDelete(id, organizationId, userId),
               canDelete: (id: number) => tipoPessoaService.canDelete(id, organizationId),
          },

          grupos: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => produtosGruposService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => produtosGruposService.getAllActive(organizationId),
               getAllWithProductCount: () => produtosGruposService.getAllWithProductCount(organizationId),
               getAllWithSubGrupos: () => produtosGruposService.getAllWithSubGrupos(organizationId),
               getById: (id: number) => produtosGruposService.getById(id, organizationId),
               create: (data: any) => produtosGruposService.create(data, organizationId, userId),
               update: (id: number, data: any) => produtosGruposService.update(id, data, organizationId, userId),
               softDelete: (id: number) => produtosGruposService.softDelete(id, organizationId, userId),
               canDelete: (id: number) => produtosGruposService.canDelete(id, organizationId),
          },

          subgrupos: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => produtosSubGruposService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => produtosSubGruposService.getAllActive(organizationId),
               getAllWithProductCount: () => produtosSubGruposService.getAllWithProductCount(organizationId),
               getById: (id: number) => produtosSubGruposService.getById(id, organizationId),
               getByGrupo: (grupoId: number) => produtosSubGruposService.getByGrupo(organizationId, grupoId),
               create: (data: any) => produtosSubGruposService.create(data, organizationId, userId),
               update: (id: number, data: any) => produtosSubGruposService.update(id, data, organizationId, userId),
               moverParaGrupo: (id: number, novoGrupoId: number) => produtosSubGruposService.moverParaGrupo(id, organizationId, novoGrupoId, userId),
               softDelete: (id: number) => produtosSubGruposService.softDelete(id, organizationId, userId),
               canDelete: (id: number) => produtosSubGruposService.canDelete(id, organizationId),
          },

          // Produtos
          produtos: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => produtosService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => produtosService.getAllActive(organizationId),
               getById: (id: number) => produtosService.getById(id, organizationId),
               getByGrupo: (grupoId: number) => produtosService.getByGrupo(organizationId, grupoId),
               getEmEstoque: () => produtosService.getEmEstoque(organizationId),
               atualizarEstoque: (id: number, quantidade: number) => produtosService.atualizarEstoque(organizationId, id, quantidade),
               create: (data: any) => produtosService.create(data, organizationId, userId),
               update: (id: number, data: any) => produtosService.update(id, data, organizationId, userId),
               softDelete: (id: number) => produtosService.softDelete(id, organizationId, userId),
          },

          // Cardápio Diário
          cardapio: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => cardapioDiarioService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => cardapioDiarioService.getAllActive(organizationId),
               getById: (id: number) => cardapioDiarioService.getById(id, organizationId),
               getByData: (data: string) => cardapioDiarioService.getByData(organizationId, data),
               getHoje: () => cardapioDiarioService.getHoje(organizationId),
               getByPeriodo: (periodo: string) => cardapioDiarioService.getByPeriodo(organizationId, periodo),
               create: (data: any) => cardapioDiarioService.create(data, organizationId, userId),
               update: (id: number, data: any) => cardapioDiarioService.update(id, data, organizationId, userId),
               softDelete: (id: number) => cardapioDiarioService.softDelete(id, organizationId, userId),
          },

          // Contratos
          contratos: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => contratosService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => contratosService.getAllActive(organizationId),
               getById: (id: number) => contratosService.getById(id, organizationId),
               getAtivos: () => contratosService.getAtivos(organizationId),
               getByTipo: (tipoId: number) => contratosService.getByTipo(organizationId, tipoId),
               create: (data: any) => contratosService.create(data, organizationId, userId),
               update: (id: number, data: any) => contratosService.update(id, data, organizationId, userId),
               softDelete: (id: number) => contratosService.softDelete(id, organizationId, userId),
          },

          // Informações do contexto atual
          context: {
               organizationId,
               userId,
               userData,
          },

          // Serviços que não precisam de contexto multi-tenant
          organizacoes: organizacoesService,

          // Serviço de relatórios otimizado com views
          relatorios: {
               getDashboardGeral: () => viewRelatorios.getDashboardGeral(organizationId),
               getRelatorioVendas: (filtros?: any) => viewRelatorios.getRelatorioVendas(organizationId, filtros),
               getRelatorioConsumoAlunos: () => viewRelatorios.getRelatorioConsumoAlunos(organizationId),
               getRelatorioProdutosMaisVendidos: (limite?: number) => viewRelatorios.getRelatorioProdutosMaisVendidos(organizationId, limite),
               getRelatorioSaldos: () => viewRelatorios.getRelatorioSaldos(organizationId),
               getRelatorioMovimentacoes: (limite?: number) => viewRelatorios.getRelatorioMovimentacoes(organizationId, limite),
               getEstatisticasRapidas: () => viewRelatorios.getEstatisticasRapidas(organizationId),
               exportarDados: (tipo: 'vendas' | 'saldos' | 'produtos' | 'movimentacoes') => viewRelatorios.exportarDados(organizationId, tipo),
          },

          // Configurações
          configuracoes: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => configuracoesService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => configuracoesService.getAllActive(organizationId),
               getById: (id: number) => configuracoesService.getById(id, organizationId),
               getByChave: (chave: string) => configuracoesService.getByChave(organizationId, chave),
               setConfiguracao: (chave: string, valor: string, descricao?: string) => configuracoesService.setConfiguracao(organizationId, chave, valor, descricao, userId),
               getValor: (chave: string, valorPadrao?: string) => configuracoesService.getValor(organizationId, chave, valorPadrao),
               getValorBoolean: (chave: string, valorPadrao?: boolean) => configuracoesService.getValorBoolean(organizationId, chave, valorPadrao),
               getValorNumber: (chave: string, valorPadrao?: number) => configuracoesService.getValorNumber(organizationId, chave, valorPadrao),
               criarConfiguracoesPadrao: () => configuracoesService.criarConfiguracoesPadrao(organizationId, userId),
               exportarConfiguracoes: () => configuracoesService.exportarConfiguracoes(organizationId),
               importarConfiguracoes: (configuracoes: Record<string, string>) => configuracoesService.importarConfiguracoes(organizationId, configuracoes, userId),
          },

          // RFID
          usuariosRfid: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => usuariosRfidService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => usuariosRfidService.getAllActive(organizationId),
               getById: (id: number) => usuariosRfidService.getById(id, organizationId),
               getByPessoa: (pessoaId: number) => usuariosRfidService.getByPessoa(organizationId, pessoaId),
               getByRfid: (codigo: string) => usuariosRfidService.getByCodigo(organizationId, codigo),
               create: (data: any) => usuariosRfidService.create(data, organizationId, userId),
               update: (id: number, data: any) => usuariosRfidService.update(id, data, organizationId, userId),
               softDelete: (id: number) => usuariosRfidService.softDelete(id, organizationId, userId),
               autenticarRfid: (tagRfid: string) => usuariosRfidService.autenticarRfid(organizationId, tagRfid),
               toggleAtivo: (id: number) => usuariosRfidService.toggleAtivo(organizationId, id, userId),
          },

          // Telefones
          telefones: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => telefonesService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getByPessoa: (pessoaId: number) => telefonesService.getByPessoa(organizationId, pessoaId),
               getPrincipalByPessoa: (pessoaId: number) => telefonesService.getPrincipalByPessoa(organizationId, pessoaId),
               setPrincipal: (pessoaId: number, telefoneId: number) => telefonesService.setPrincipal(organizationId, pessoaId, telefoneId),
               create: (data: any) => telefonesService.create(data, organizationId, userId),
               update: (id: number, data: any) => telefonesService.update(id, data, organizationId, userId),
               softDelete: (id: number) => telefonesService.softDelete(id, organizationId, userId),
          },

          // Endereços
          enderecos: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => enderecosService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getByPessoa: (pessoaId: number) => enderecosService.getByPessoa(organizationId, pessoaId),
               getPrincipalByPessoa: (pessoaId: number) => enderecosService.getPrincipalByPessoa(organizationId, pessoaId),
               getByCep: (cep: string) => enderecosService.getByCep(organizationId, cep),
               getByCidade: (cidade: string) => enderecosService.getByCidade(organizationId, cidade),
               getByTipo: (tipo: string) => enderecosService.getByTipo(organizationId, tipo),
               setPrincipal: (enderecoId: number, pessoaId: number) => enderecosService.setPrincipal(organizationId, enderecoId, pessoaId, userId),
               create: (data: any) => enderecosService.create(data, organizationId, userId),
               update: (id: number, data: any) => enderecosService.update(id, data, organizationId, userId),
               softDelete: (id: number) => enderecosService.softDelete(id, organizationId, userId),
          },

          // Créditos
          // creditos: {
          //     getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => creditosService.getAll(organizationId, page, pageSize, sortModel, filterModel),
          //     getAllActive: () => creditosService.getAllActive(organizationId),
          //     getByFaixaValor: (valorMin: number, valorMax: number) => creditosService.getByFaixaValor(organizationId, valorMin, valorMax),
          //     getOrderedByValue: (ascending?: boolean) => creditosService.getOrderedByValue(organizationId, ascending),
          //     create: (data: any) => creditosService.create(data, organizationId, userId),
          //     update: (id: number, data: any) => creditosService.update(id, data, organizationId, userId),
          //     softDelete: (id: number) => creditosService.softDelete(id, organizationId, userId),
          // },          // Depósitos de Créditos
          // creditosDepositos: {
          //     getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => creditosDepositosService.getAll(organizationId, page, pageSize, sortModel, filterModel),
          //     getByResponsavel: (responsavelId: number) => creditosDepositosService.getByResponsavel(organizationId, responsavelId),
          //     getByPagamento: (pagamentoId: number) => creditosDepositosService.getByPagamento(organizationId, pagamentoId),
          //     getByPeriodo: (dataInicio: string, dataFim: string) => creditosDepositosService.getByPeriodo(organizationId, dataInicio, dataFim),
          //     create: (data: any) => creditosDepositosService.create(data, organizationId, userId),
          // },          // Transferências para Dependentes
          // creditosDependentes: {
          //     getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => creditosDependentesService.getAll(organizationId, page, pageSize, sortModel, filterModel),
          //     getByResponsavel: (responsavelId: number) => creditosDependentesService.getByResponsavel(organizationId, responsavelId),
          //     getByAluno: (alunoId: number) => creditosDependentesService.getByAluno(organizationId, alunoId),
          //     getByPeriodo: (dataInicio: string, dataFim: string) => creditosDependentesService.getByPeriodo(organizationId, dataInicio, dataFim),
          //     getTotalByResponsavel: (responsavelId: number) => creditosDependentesService.getTotalByResponsavel(organizationId, responsavelId),
          //     create: (data: any) => creditosDependentesService.create(data, organizationId, userId),
          // },          // Tipo de Unidade
          tipoUnidade: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => tipoUnidadeService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getAllActive: () => tipoUnidadeService.getAllActive(organizationId),
               getUnidadesComControleEstoque: () => tipoUnidadeService.getUnidadesComControleEstoque(organizationId),
               getByQuantidadeMinima: (qtdMin: number) => tipoUnidadeService.getByQuantidadeMinima(organizationId, qtdMin),
               create: (data: any) => tipoUnidadeService.create(data, organizationId, userId),
               update: (id: number, data: any) => tipoUnidadeService.update(id, data, organizationId, userId),
               softDelete: (id: number) => tipoUnidadeService.softDelete(id, organizationId, userId),
          },

          // Solicitações
          solicitacoes: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => solicitacoesService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getByNumero: (numeroSolicitacao: number) => solicitacoesService.getByNumero(organizationId, numeroSolicitacao),
               getByVenda: (vendaId: number) => solicitacoesService.getByVenda(organizationId, vendaId),
               getByEstado: (codigoEstado: number) => solicitacoesService.getByEstado(organizationId, codigoEstado),
               getPendentes: () => solicitacoesService.getPendentes(organizationId),
               getExpiradas: () => solicitacoesService.getExpiradas(organizationId),
               getByConciliacao: (codigoConciliacao: string) => solicitacoesService.getByConciliacao(organizationId, codigoConciliacao),
               create: (data: any) => solicitacoesService.create(data, organizationId, userId),
          },

          // Pagamentos
          pagamentos: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => pagamentosService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getByNumero: (numeroPagamento: number) => pagamentosService.getByNumero(organizationId, numeroPagamento),
               getByEstado: (codigoEstado: number) => pagamentosService.getByEstado(organizationId, codigoEstado),
               getEfetivados: () => pagamentosService.getEfetivados(organizationId),
               getCancelados: () => pagamentosService.getCancelados(organizationId),
               getByConciliacao: (codigoConciliacao: string) => pagamentosService.getByConciliacao(organizationId, codigoConciliacao),
               getByPeriodo: (dataInicio: string, dataFim: string) => pagamentosService.getByPeriodo(organizationId, dataInicio, dataFim),
               getTotalByPeriodo: (dataInicio: string, dataFim: string) => pagamentosService.getTotalByPeriodo(organizationId, dataInicio, dataFim),
               create: (data: any) => pagamentosService.create(data, organizationId, userId),
          },

          // Movimentações de Saldo
          // movimentacoesSaldo: {
          //     getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => movimentacoesSaldoService.getAll(organizationId, page, pageSize, sortModel, filterModel),
          //     getByPessoa: (pessoaId: number) => movimentacoesSaldoService.getByPessoa(organizationId, pessoaId),
          //     getByTipo: (tipoMovimentacao: 'credito' | 'debito') => movimentacoesSaldoService.getByTipo(organizationId, tipoMovimentacao),
          //     getByOrigem: (tipoOrigem: string) => movimentacoesSaldoService.getByOrigem(organizationId, tipoOrigem),
          //     getByPeriodo: (dataInicio: string, dataFim: string) => movimentacoesSaldoService.getByPeriodo(organizationId, dataInicio, dataFim),
          //     getByOrigemId: (origemId: number, tipoOrigem: string) => movimentacoesSaldoService.getByOrigemId(organizationId, origemId, tipoOrigem),
          //     getTotalCreditos: (pessoaId: number) => movimentacoesSaldoService.getTotalCreditos(organizationId, pessoaId),
          //     getTotalDebitos: (pessoaId: number) => movimentacoesSaldoService.getTotalDebitos(organizationId, pessoaId),
          //     create: (data: any) => movimentacoesSaldoService.create(data, organizationId, userId),
          // },          // Relacionamentos Pessoa-Organização
          pessoasOrganizacoes: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => pessoasOrganizacoesService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getByPessoa: (pessoaId: number) => pessoasOrganizacoesService.getByPessoa(organizationId, pessoaId),
               getAtivos: () => pessoasOrganizacoesService.getAtivos(organizationId),
               getByTipoPessoa: (tipoPessoaId: number) => pessoasOrganizacoesService.getByTipoPessoa(organizationId, tipoPessoaId),
               getByPeriodo: (dataInicio: string, dataFim?: string) => pessoasOrganizacoesService.getByPeriodo(organizationId, dataInicio, dataFim),
               desativar: (id: number) => pessoasOrganizacoesService.desativar(organizationId, id, userId),
               create: (data: any) => pessoasOrganizacoesService.create(data, organizationId, userId),
               update: (id: number, data: any) => pessoasOrganizacoesService.update(id, data, organizationId, userId),
          },

          // Relacionamentos Dependentes
          pessoasDependentes: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => pessoasDependentesService.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getByResponsavel: (responsavelId: number) => pessoasDependentesService.getByResponsavel(organizationId, responsavelId),
               getByAluno: (alunoId: number) => pessoasDependentesService.getByAluno(organizationId, alunoId),
               isDependente: (alunoId: number, responsavelId: number) => pessoasDependentesService.isDependente(organizationId, alunoId, responsavelId),
               getTodosAlunos: () => pessoasDependentesService.getTodosAlunos(organizationId),
               getTodosResponsaveis: () => pessoasDependentesService.getTodosResponsaveis(organizationId),
               countDependentes: (responsavelId: number) => pessoasDependentesService.countDependentes(organizationId, responsavelId),
               create: (data: any) => pessoasDependentesService.create(data, organizationId, userId),
               update: (id: number, data: any) => pessoasDependentesService.update(id, data, organizationId, userId),
               softDelete: (id: number) => pessoasDependentesService.softDelete(id, organizationId, userId),
          },

          // Itens de Vendas
          vendasItens: {
               getByVenda: (vendaId: number) => vendasItensService.getByVenda(vendaId),
               getByProduto: (produtoId: number) => vendasItensService.getByProduto(produtoId),
               getTotalVendasProduto: (produtoId: number) => vendasItensService.getTotalVendasProduto(produtoId),
               getValorTotalVenda: (vendaId: number) => vendasItensService.getValorTotalVenda(vendaId),
               create: (data: any) => vendasItensService.create(data),
               update: (id: number, data: any) => vendasItensService.update(id, data),
               delete: (id: number) => vendasItensService.delete(id),
          },

          // Sistema de Origem (global - sem multi-tenant)
          sistemaOrigem: {
               getAllActive: () => sistemaOrigemService.getAllActive(),
               getById: (id: number) => sistemaOrigemService.getById(id),
               getByCodigo: (codigo: string) => sistemaOrigemService.getByCodigo(codigo),
               getByPrefixo: (prefixo: string) => sistemaOrigemService.getByPrefixo(prefixo),
               create: (data: any) => sistemaOrigemService.create(data),
               update: (id: number, data: any) => sistemaOrigemService.update(id, data),
               toggleAtivo: (id: number) => sistemaOrigemService.toggleAtivo(id),
               delete: (id: number) => sistemaOrigemService.delete(id),
          },

          // Views adicionais
          conciliacaoVendas: {
               getAll: (page: number, pageSize: number, sortModel?: any, filterModel?: any) => viewConciliacaoVendas.getAll(organizationId, page, pageSize, sortModel, filterModel),
               getPendentes: () => viewConciliacaoVendas.getPendentes(organizationId),
               getDivergentes: () => viewConciliacaoVendas.getDivergentes(organizationId),
               getByStatus: (status: 'PENDENTE' | 'CONCILIADO' | 'DIVERGENTE') => viewConciliacaoVendas.getByStatus(organizationId, status),
               getByCodigo: (codigo: string) => viewConciliacaoVendas.getByCodigo(organizationId, codigo),
               getByPeriodo: (dataInicio: string, dataFim: string) => viewConciliacaoVendas.getByPeriodo(organizationId, dataInicio, dataFim),
               getEstatisticas: () => viewConciliacaoVendas.getEstatisticas(organizationId),
          },

          // Views de Saldos (Database-Driven)
          viewSaldosResponsaveis: {
               getSaldosResponsaveis: () => viewSaldosResponsaveis.getSaldosResponsaveis(organizationId),
               getSaldoPorResponsavel: (responsavelId: number) => viewSaldosResponsaveis.getSaldoPorResponsavel(organizationId, responsavelId),
               getResponsaveisSaldoBaixo: (limiteMinimo?: number) => viewSaldosResponsaveis.getResponsaveisSaldoBaixo(organizationId, limiteMinimo),
               getTotalSaldos: () => viewSaldosResponsaveis.getTotalSaldos(organizationId),
               getEstatisticasSaldos: () => viewSaldosResponsaveis.getEstatisticasSaldos(organizationId),
          },

          viewSaldosAlunos: {
               getSaldosAlunos: () => viewSaldosAlunos.getSaldosAlunos(organizationId),
               getSaldoPorAluno: (alunoId: number) => viewSaldosAlunos.getSaldoPorAluno(organizationId, alunoId),
               getAlunosPodemComprar: () => viewSaldosAlunos.getAlunosPodemComprar(organizationId),
               getAlunosSaldoBaixo: (limiteMinimo?: number) => viewSaldosAlunos.getAlunosSaldoBaixo(organizationId, limiteMinimo),
               getAlunosPorResponsavel: (responsavelId: number) => viewSaldosAlunos.getAlunosPorResponsavel(organizationId, responsavelId),
               getTotalSaldosAlunos: () => viewSaldosAlunos.getTotalSaldosAlunos(organizationId),
          },

          viewMovimentacoesRecentes: {
               getMovimentacoesRecentes: (limite?: number) => viewMovimentacoesRecentes.getMovimentacoesRecentes(organizationId, limite),
               getMovimentacoesPorTipo: (tipoMovimentacao: 'credito' | 'debito') => viewMovimentacoesRecentes.getMovimentacoesPorTipo(organizationId, tipoMovimentacao),
               getMovimentacoesPorPessoa: (pessoaId: number) => viewMovimentacoesRecentes.getMovimentacoesPorPessoa(organizationId, pessoaId),
               getMovimentacoesPorPeriodo: (dataInicio: string, dataFim: string) => viewMovimentacoesRecentes.getMovimentacoesPorPeriodo(organizationId, dataInicio, dataFim),
               getMovimentacoesPorOrigem: (tipoOrigem: string) => viewMovimentacoesRecentes.getMovimentacoesPorOrigem(organizationId, tipoOrigem),
               getTotalPorTipo: () => viewMovimentacoesRecentes.getTotalPorTipo(organizationId),
          },

          // Funções de RFID
          rfidFunctions: {
               autenticar: (codigoRfid: string) => rfidFunctionsService.autenticarRfid(codigoRfid),
               gerenciar: (pessoaId: number, codigoRfid?: string) => rfidFunctionsService.gerenciarRfid(pessoaId, userId, codigoRfid),
          },

          // Funções de Saldo
          saldoFunctions: {
               adicionarCreditoResponsavel: (idResponsavel: number, valor: number, descricao?: string) => saldoFunctionsService.adicionarCreditoResponsavel(idResponsavel, valor, organizationId, descricao, userId),
               transferirCreditoParaAluno: (idResponsavel: number, idAluno: number, valor: number) => saldoFunctionsService.transferirCreditoParaAluno(idResponsavel, idAluno, valor, organizationId, userId),
               verificarLimiteAluno: (idAluno: number, valorCompra: number) => saldoFunctionsService.verificarLimiteAluno(idAluno, valorCompra, organizationId),
          },

          // Funções de Dashboard
          dashboardFunctions: {
               obterDashboardCoordenador: () => dashboardFunctionsService.obterDashboardCoordenador(organizationId),
               obterDashboardOperador: () => dashboardFunctionsService.obterDashboardOperador(organizationId),
               obterDashboardResponsavel: () => dashboardFunctionsService.obterDashboardResponsavel(userId, organizationId),
          },

          // Funções de Dependentes
          dependentesFunctions: {
               distribuirSaldoDependente: (idAluno: number, valor: number, observacoes?: string) => dependentesFunctionsService.distribuirSaldoDependente(userId, idAluno, organizationId, valor, observacoes),
               transferirEntreDependentes: (idAlunoOrigem: number, idAlunoDestino: number, valor: number, observacoes?: string) => dependentesFunctionsService.transferirEntreDependentes(userId, idAlunoOrigem, idAlunoDestino, organizationId, valor, observacoes),
          },

          // Funções de Venda
          vendaFunctions: {
               processar: (idPessoa: number, itens: any[], desconto?: number, observacoes?: string) => vendaFunctionsService.processarVenda(idPessoa, userId, organizationId, itens, desconto, observacoes),
          },
     };
};

export default useMultiTenantServices;
